<tr-viewer
    [containerStyle]="viewerContainerStyle"
    [serviceUrl]="reportServiceUrl"
    [reportSource]="reportSource"
    [viewMode]="'INTERACTIVE'"
    [scaleMode]="'SPECIFIC'"
    [scale]="1.0">
</tr-viewer>